import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20illustration%2C%20vibrant%20colorful%20anime%20cityscape%20with%20cherry%20blossoms%2C%20warm%20sunset%20orange%20and%20pink%20sky%2C%20stylized%20fantasy%20world%2C%20soft%20artistic%20brush%20texture%2C%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20rich%20warm%20tones&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
        alt="汗汗漫画 - 免费韩国漫画在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
            汗汗漫画
          </h1>
          <p className="text-base md:text-xl text-background-50/90 mb-3">
            免费韩国漫画 · 韩漫大全在线阅读
          </p>
          <p className="text-sm md:text-base text-background-50/70 max-w-xl mx-auto leading-relaxed mb-8">
            汇集海量韩国漫画资源，涵盖恋爱、奇幻、动作、悬疑等热门题材，无需付费即可畅享正版韩漫，随时随地轻松阅读
          </p>

          {/* Stats */}
          <div className="flex items-center justify-center gap-6 md:gap-12 mb-8">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">{siteInfo.stats.totalComics}</div>
              <div className="text-xs md:text-sm text-background-50/70 mt-1">漫画资源</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">{siteInfo.stats.totalReaders}</div>
              <div className="text-xs md:text-sm text-background-50/70 mt-1">注册读者</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">{siteInfo.stats.dailyActive}</div>
              <div className="text-xs md:text-sm text-background-50/70 mt-1">日活跃用户</div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all duration-300 whitespace-nowrap text-sm md:text-base"
            >
              开始阅读
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-full backdrop-blur-sm transition-all duration-300 whitespace-nowrap text-sm md:text-base border border-background-50/20"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/40 flex items-start justify-center pt-2">
          <div className="w-1 h-2 bg-background-50/60 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}